<template>
  <div>
    
    <div class="TopBar">



      <el-row :span="24" type="flex" align="bottom">

        <el-col :xs="7" :sm="7" :lg="14">

          <div style="padding: 6px 30px; display: flex;align-items: center;">
            <i @click="drawer=true" class="el-icon-s-unfold hidden-md-and-up" style="color: #fff;margin-left: -15px;margin-right: 0px;cursor: pointer;font-size: 30px;"></i>
            <router-link to="/">
              <img src="@/assets/logo.png" style="height: 55px;" alt=""/>  
            </router-link>
          </div>

        </el-col>
        


        <el-col class="hidden-xs-only" :sm="10" :lg="6"> 
          
          <div class="search_div">
            <div class="search_button">
              <router-link v-if="this.keys" :to="'Search?keys='+this.keys"><i class="el-icon-search" style="margin: 0px 0 0 20px;cursor: pointer;"></i></router-link>
            </div>
            <input maxlength="20" style="width: 100%;" placeholder="띄어쓰기 정확히 입력해주세요" v-model="keys" class="search_input" type="text" @keyup.enter="keys!==''?Search():null"/>
          </div>

        </el-col>
        
        <el-col :xs="17" :sm="6" :lg="4" class="font_Arial" style="text-align: right;padding: 10px 20px;color: rgb(216, 157, 37);font-size: 14px;"> 
          
          <a href="https://t.me/ioi369" target="_blank" rel="noopener noreferrer">
            <i class="el-icon-s-promotion" style="margin: 15px 0 0 20px;cursor: pointer;"></i> 
            제휴광고 문의
          </a>

        </el-col>

      </el-row>

    </div>


    <el-drawer
      class="scrollbar"
      title=""
      :visible.sync="drawer"
      :direction="direction">

      <div class="search_div hidden-sm-and-up" style="padding: 10px;">
        <div class="search_button" style="top:13px;right: 15px;">
          <router-link v-if="this.keys" :to="'Search?keys='+this.keys"><i class="el-icon-search" style="margin-left: 20px;cursor: pointer;"></i></router-link>
        </div>
        <input maxlength="20" style="width: 220px;" placeholder="키워드" v-model="keys" class="search_input" type="text" @keyup.enter="keys!==''?Search():null">
      </div>


      <el-collapse v-model="activeNames" @change="handleChange">
          
        <a href="/">
          <div style="padding-left: 20px;" class="el-collapse-item__header" @click="drawer=false">
                                              
            <i class="fa-solid fa-house-chimney"></i>
            <span style="padding-left: 5px;">홈</span>  

          </div>
        </a>

        <router-link to="Top">
          <div style="padding-left: 20px;" class="el-collapse-item__header" @click="drawer=false">
            <div>
              <i style="color:red;" class="fa-solid fa-fire fa-beat"></i>
              <span style="padding-left: 5px;">인기영상</span>
            </div>
          </div>
        </router-link>
        
        <el-collapse-item name="1">
          <template slot="title">
            <span style="padding-left: 20px;">
              <i class="fa-solid fa-tv"></i> VOD
            </span>
          </template>
          <div>

            <div style="padding-left: 20px;">
              <el-collapse-item name="1-1">
                <template slot="title">
                  <span style="padding-left: 20px;">
                    <i style="color:#55f;" class="fa-solid fa-circle-play"></i>
                    영화
                  </span>
                </template>
                <div style="padding-left: 40px;">
                  
                  <router-link to="Type?type=1&type2=137">
                    <div class="left_menu_s" @click="drawer=false">한국 영화</div>
                  </router-link>
                  <router-link to="Type?type=1&type2=9999">
                    <div class="left_menu_s" @click="drawer=false">해외 영화</div>
                  </router-link>

                </div>
              </el-collapse-item>

            </div>

            <div style="padding-left: 20px;">
              <el-collapse-item name="1-2">
                <template slot="title">
                  <span style="padding-left: 20px;">
                    <i style="color:#bbff66;" class="fa-solid fa-video"></i>
                    드라마
                  </span>
                </template>
                <div style="padding-left: 40px;">
                  
                  <router-link to="Type?type=2&type2=3">
                    <div class="left_menu_s" @click="drawer=false">한국 드라마</div>  
                  </router-link>
                  <router-link to="Type?type=2&type2=9999">
                    <div class="left_menu_s" @click="drawer=false">해외 드라마</div>
                  </router-link>

                </div>
              </el-collapse-item>

            </div>

 
            <div style="padding-left: 40px;">
                
              <router-link to="Type?type=3">
                <div class="left_menu_s" @click="drawer=false">예능</div>
              </router-link>
              <router-link to="Type?type=4">
                <div class="left_menu_s" @click="drawer=false">시사</div>
              </router-link>
              <router-link to="Type?type=5">
                <div class="left_menu_s" @click="drawer=false">애니메이션</div>
              </router-link>
              <router-link to="Type?type=6">
                <div class="left_menu_s" @click="drawer=false">OTT예능</div>
              </router-link>
              <router-link to="Type?type=9">
                <div class="left_menu_s" @click="drawer=false">지난드라마</div>
              </router-link>
            </div>

          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span style="padding-left: 20px;">
              <i class="el-icon-link"></i> 링크동맹
            </span>
          </template>
          <div style="padding-left: 40px;">
            <router-link :to="'Link?type='+item.type" v-for="(item,index) in linktype" :key="index">
              <div class="left_menu_s" @click="drawer=false">{{ item.title }}</div>
            </router-link>
          </div>
        </el-collapse-item>

      </el-collapse>

      <div style="padding-left: 16px;" class="el-collapse-item__header">
        <div>
          
          <a href="https://herb-ming.com/?re=bbtv" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/ico10.png" width="20" alt="">
            <span style="padding-left: 5px;">비아그라 / 위고비</span>
          </a>

        </div>
      </div>
      

      <!-- 广告 -->
      <div style="margin-bottom: 20px;">

        <el-row :span="24" :gutter="0">

          <el-col :span="24" v-for="(item,index) in adlist3" :key="index">
            
            <a :href="item.url" target="_blank" rel="noopener noreferrer">
              <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="item.image" fit="cover" >
                <template #error>
                  <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                </template>
              </el-image>
            </a>

          </el-col>

        </el-row>

      </div>
      <!-- 广告 -->

    </el-drawer>
    
  </div>
</template>

<script>
export default {
  name: 'TopNav',
  data(){
    return{
      activeNames: ['0'],
      keys:'',
      direction: 'ltr',
      drawer:false
    }
  },
  props: {
    linktype:[],
    adlist3:[]
  },
  methods: {
    handleChange(){},
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);

      this.drawer = false
      switch(key){
        // case '9'://已完结电视剧
        //   this.goTo('/Type?type=1-0&page=1')
        //   break
        // case '91'://最新更新
        //   this.goTo('/PageUpdate')
        //   break
        // case '92'://最新更新
        //   window.open("https://herbmming2.com/?re=cytv","_blank")
        //   break
        case '100'://广告
          window.open("https://www.inkomall2.com/%EC%84%B1%EC%83%9D%ED%99%9C?utm_source=ootv&utm_medium=display&utm_campaign=category&utm_content=ed","_blank")
          break
        default:
          this.goTo('/Type?type='+key)
      }
    },
    goTo(path) {
      if (path !== this.$router.currentRoute.fullPath) {
        // console.log(path)
        this.loading = true
        this.$router.push(path);
      }
    },
    Search() {
      var path = '/Search?keys='+ encodeURIComponent(this.keys) + '&type0=0&type1=0&type2=0&type3=0&type4=0&limit=30&page=1'

      // console.log(path , this.$router.currentRoute.fullPath)
      if (path !== this.$router.currentRoute.fullPath) {
        this.loading = true
        // this.$router.push(path);
        this.$router.replace({
          path:'/Search',
          query:{keys:this.keys,
            type0:0,type1:0,type2:0,type3:0,type4:0,limit:30,page:1}
        })

        this.drawer = false
      }
    },
  }
}
</script>
<style>
  .TopBar{
    /* background-color: #000; */
    /* background-image: linear-gradient(to bottom, #000 0%,#000 35%, #3768b4 100%); */
    background-image: linear-gradient(to bottom, #000 0%,#000 35%, rgb(55, 104, 180) 90%, rgb(55, 104, 180,0) 100%);
    /* background-image: linear-gradient(to bottom, rgba(0 0, 0, 1), rgba(55, 104, 180, 0.7)); */
    /* background: linear-gradient(0deg, transparent 0%, rgb(55, 104, 180) 5%, rgb(55, 104, 180) 7%, rgb(0,0,0) 70%, rgb(0,0,0) 100%); */
    height: 85px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.13);    
    width: 100%;
    /* display: flex; */
    /* flex-wrap: wrap; */
    align-items: center;
    /* padding: 20px 30px; */
    /* position: fixed; */
    left: 0;
    top: 0;
    z-index: 4;
    
    font-size: 20px
    
  }
  .TopBar div{
    text-align: left;
    justify-content: flex-start;
    align-items:start;
  }

  .TopBar .Nav {
    display: flex;
    /* flex-wrap: wrap; */
    align-items: center;
    padding: 25px 30px;
    position: fixed;
  }
  .TopBar .menu {
    /* width: 100px; */
    padding-right: 20px;
    font-size: 18px;
    /* color: rgb(43, 165, 69); */
  }


  .col_Nav{
    padding-top: 28px;    
  }

  .col_Nav .menu {
    /* width: 100px; */
    font-size: 15px;
    /* color: rgb(43, 165, 69); */
    color: #fff;
    text-align: center;
  }

  

  .search_div{
    position: relative;
    /* padding: 15px 20px; */
    /* margin: 16px; */
    margin: 16px;
  }
  .search_button{
    position: absolute;
    z-index: 1000;
    top:3px;
    right: -10px;
    color: #000;
    padding: 7px ;
  }

  .search_input{
    position: relative;
    background-color: #eee;
    line-height: 30px;
    /* width: 100%; */
    border: 1px solid #ccc;
    /* margin: 0 10px; */
    padding: 3px 10px;
    border-radius: 8px;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7)); 
  }
  .search_input:focus {
    outline: none; 
    background-color: #FFF;
  }



  .el-divider {
    z-index: 90!important;
    background-color: #333;
    position: relative;
  }

  .el-drawer {
    z-index: 90!important;
    /* background: rgba(17,17,17, 1)!important; */
    /* background: linear-gradient(-90deg, transparent 0%, rgb(17,17,17) 20%, rgb(17,17,17) 100%)!important; */
    width: 300px!important;
    /* background-color: rgb(0, 0, 0) !important; */
    background-color: rgb(51,51,51) !important;
  }
  .v-modal {
    z-index: 1!important;
  }
  .el-drawer__header{
    margin-bottom: 0!important;
    padding: 0!important;
  }

  .el-menu{
    z-index: 10px;
    border-right: 0 !important;/*去掉element menu的右侧边框 */
    border-radius: 5px!important;
    /* background-image: linear-gradient(135deg, #312529 10%, #312529 100%) !important; */
    /* background-color: rgb(0, 0, 0) !important; */
    background-color: rgb(51,51,51) !important;
  }
  .el-menu span{
    padding-left: 15px;
    font-size: 13px;
    color: #FFF;
    font-size: 18px !important;
  }
  /* 菜單被選中的背景色 */
  .el-menu .el-menu-item.is-active {
    background-color: #2b2b2b !important;
    color: #FFF !important;
    font-size: 18px !important;
    border-right: 3px solid var(--primary-dark, #FBA429);
  }
  /* 普通菜单1 */
  .el-menu-item:hover {
    background-color: #2e2e2e !important;
    font-size: 18px !important;
    /* color: #FFF !important; */
  }
  
  /* 子母菜单2 */
  .el-submenu__title:hover {
    background-color: #2C2C2C !important;
    font-size: 18px !important;
    /* color: #FFF !important; */
  }

  /* 菜單1 */
  .el-menu .el-menu-item{
    border-radius: 6px 0 0 6px;
    font-size: 18px !important;
    /* color: #FFF !important; */
  }
  /* 子母菜單2 */
  .el-submenu__title{
    border-radius: 6px 0 0 6px;
  }
</style>
